/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "sa-east-1",
    "aws_appsync_graphqlEndpoint": "https://7rmi4jxhjjhxvkjau2soyrokqy.appsync-api.sa-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "sa-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-qjyq6jy7ovhrxddfuem3n3d7ae",
    "aws_cognito_identity_pool_id": "sa-east-1:43e3e9be-6a0e-48f2-be67-cbaf1fa245ad",
    "aws_cognito_region": "sa-east-1",
    "aws_user_pools_id": "sa-east-1_3fxjYKrDl",
    "aws_user_pools_web_client_id": "6nscj912840bjq9ok94gjs19vj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "checkview-master-bucket181942-staging",
    "aws_user_files_s3_bucket_region": "sa-east-1"
};


export default awsmobile;
